export default "__VITE_ASSET__mV1iYjCB__"